import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${(props) => props.theme.colors.card};
  padding: 10px 15px;
  gap: 15px;
  border-radius: 5px;
  border: 0.5px solid rgba(128, 128, 128, 0.2);
  cursor: pointer;
`;

export const FileContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Name = styled.h3``;

export const Size = styled.p``;
